import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Dialog from "sap/m/Dialog";
import { DiscontinuedArticle } from "vamos/cockpit/model/odata/VamosModel";
import { Button$PressEvent } from "sap/m/Button";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";

/**
 * @namespace vamos.cockpit.data.masterdata.bmecat.discontinueditems.controller
 */

export interface NotReplacedDialogViewModel {
    guids: string[];
    reason:string;

}
export default class IgnoreReplacementDialogController extends BaseTypeController {
    private dialog: Dialog;
    private saveCallBack:()=>void|undefined;
    private dataModel: JSONModel;
    onInit(){
        super.onInit();
        this.dataModel = new JSONModel();
        this.setModel(this.dataModel,"data");

        this.dialog = this.getView().byId("ignoreReplacementDialog") as Dialog;

    }
    openDialog(guids:string[], saveCallBack:()=>void):void{
        this.saveCallBack = saveCallBack;
        const data:NotReplacedDialogViewModel ={
            guids:guids,
            reason:undefined,
        }
        ValidationUtil.clearRequiredFields(this.dialog);
        const infoText:string = this.getText("IgnoreDialog.Text", [guids.length]);
        this.viewModel.setProperty("/infoText",infoText);
        this.dataModel.setData(data);
        this.dialog.open();
    }
    onClose(){
        this.dialog.close();
    }
    private async onMarkAsIgnored(){
        if(ValidationUtil.hasEmptyRequiredFields(this.dialog)) return;
        const payload = this.dataModel.getData() as NotReplacedDialogViewModel;
        await ApiService.getInstance().postRestJsonData(`/discontinued-product/ignore`, payload);
        this.saveCallBack?.();
        this.dialog.close();



    }



}